import { ActivityStatus, cn, Icon } from "@cca/components";

export function iconPropsByActivityStatus(activityStatus: string) {
  const withCommonClasses = (className: string) => cn("text-base", className);

  switch (activityStatus) {
    case ActivityStatus.NotStarted:
      return {
        type: "lock",
        className: withCommonClasses("text-gray-500"),
      } as const;

    case ActivityStatus.InProgress:
      return {
        type: "play-circle",
        className: withCommonClasses("text-blue-600"),
      } as const;

    case ActivityStatus.Completed:
      return {
        type: "circle-check",
        className: withCommonClasses("text-green-900"),
      } as const;

    default:
      return {
        type: "file-lines",
        className: withCommonClasses("text-blue-600"),
      } as const;
  }
}

export type ActivityProgressIconProps = {
  activityStatus: ActivityStatus;
  className?: string;
};

export const ActivityProgressIcon = ({
  activityStatus,
  className,
}: ActivityProgressIconProps) => {
  const { type, className: defaultClassName } =
    iconPropsByActivityStatus(activityStatus);

  return <Icon className={cn(defaultClassName, className)} type={type} />;
};
